import repository from '@/services/repository';

const resource = '/invoices';

export default {
    lookup(options: any, projectId?: string, metadata?: string) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        if (projectId) {
            return repository.post(`${resource}/lookup?projectId=${projectId}`, formData, {
                headers: {'Content-Type': 'multipart/form-data' },
            });
        }

        if (metadata) {
            return repository.post(`${resource}/lookup?metadata=${metadata}`, formData, {
                headers: {'Content-Type': 'multipart/form-data' },
            });
        }

        return repository.post(`${resource}/lookup`, formData, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
};
